<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte'
    import type { MedialistEntity } from '../../modules/toolsApi/academy/medialists/medialist.entity'
    import type { MediaEntity } from '../../modules/toolsApi/academy/medias/media.entity'
    import { utils } from 'xlsx'
    import Fa from 'svelte-fa'
    import { faTimes } from '@fortawesome/free-solid-svg-icons'
    import dayjs from 'dayjs'
    import { Store } from '../../modules/infra/store.service'
    const dispatch = createEventDispatcher()

    let player

    export let playlist: MedialistEntity = null
    export let video: MediaEntity = null
    let mediaId: string = null

    function goClose() {
        dispatch('close')
    }

    function goSelect(_mediaId: string, time: number = 0) {
        video = playlist.medias.find((m) => m.media.mediaId === _mediaId)?.media
        if (!video) return
        console.log('video-selected', video)
        mediaId = _mediaId
        player.src = video.content.videoUrl + '&token=' + window.store.token.token
        player.load()
        player.currentTime = time
        player.play()
    }

    onMount(() => {
        if (playlist?.medias.length > 0) {
            if (window.store.player) {
                if (playlist.medias.some((m) => m.mediaId === window.store.player.mediaId)) {
                    goSelect(window.store.player.mediaId, window.store.player.time)
                }
            }
            if (!video) {
                goSelect(playlist.medias[0].media.mediaId)
            }
        }
        player.addEventListener('ended', () => {
            goNext()
        })

        player.addEventListener('timeupdate', () => {
            timeMonitor()
        })
    })

    function goNext() {
        const index = playlist.medias.findIndex((m) => m.media.mediaId === video.mediaId)
        if (index < playlist.medias.length - 1) {
            goSelect(playlist.medias[index + 1].media.mediaId)
        }
    }

    let currentSecond = 0
    function timeMonitor() {
        if (!player) return
        if (Math.floor(player.currentTime) === currentSecond) return
        currentSecond = Math.floor(player.currentTime)
        window.store.player = {
            mediaId,
            time: Math.floor(player.currentTime),
        }
    }
</script>

<div class="ac-player_outer scroll-dark">
    <div class="ac-player">
        <div class="ac-player_close" on:click={goClose}>
            <Fa icon={faTimes}></Fa>
        </div>
        <div class="ac-player_title">{playlist?.title}</div>
        <div class="ac-player_description">{playlist?.description || ''}</div>
        <div class="ac-player_content">
            <div class="-player">
                <video bind:this={player} id="academyPlayer" controls></video>
                <div class="-player_title">{video?.title || ''}</div>
                {#if video?.description}
                    <div class="-player_desc">{video.description}</div>
                {/if}
                {#if video?.createdAt}
                    <div class="-player_time">Publicado em {dayjs(video.createdAt).format('DD/MM/YYYY')}</div>
                {/if}
            </div>

            <div class="-plist">
                <div class="-plist-list">
                    {#each playlist.medias as media}
                        <div class="-plist-item" class:-active={video && video.mediaId === media.media.mediaId} on:click={() => goSelect(media.mediaId)}>
                            <div class="-plist-item-thumb">
                                <img src={media.media.thumbnailUrl || '/img/academy-icon.png'} alt="" />
                            </div>
                            <div class="-plist-item-content">
                                <div class="-plist-item-title">{media.media?.title || ''}</div>
                                {#if media.media.description}
                                    <div class="-plist-item-desc">{media.media?.description || ''}</div>
                                {/if}
                                <!-- {#if media.media.createdAt}
                                    <div class="-plist-item-time">{window.api.utils.utils.dateFriendly(media.media.createdAt)}</div>
                                {/if} -->
                            </div>
                        </div>
                    {/each}
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .ac-player_outer {
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        background-color: #222;
        z-index: 2;
        overflow: auto;
    }
    .ac-player {
        max-width: 1600px;
        margin: 0 auto;
        padding: 16px;
    }
    .ac-player_close {
        position: absolute;
        top: 16px;
        right: 16px;
        cursor: pointer;
        font-size: 24px;
        border: 2px solid #99999930;
        border-radius: 8px;
        width: 45px;
        height: 45px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .ac-player_title {
        font-size: 27px;
    }
    .ac-player_description {
        opacity: 0.8;
        padding-bottom: 16px;
    }
    .ac-player_content {
        display: flex;
        width: 100%;
    }

    .ac-player .-player {
        flex: 1 1 auto;
    }
    .ac-player .-player video {
        border-radius: 16px;
        width: 100%;
        max-height: 70vh;
    }
    .ac-player .-player_title {
        font-size: 20px;
    }
    .ac-player .-player_desc {
        opacity: 0.8;
    }
    .ac-player .-player_time {
        opacity: 0.8;
    }

    .ac-player .-plist {
        flex: 0 0 420px;
        background: #66666620;
        padding: 8px 16px 0px 16px;
        margin-left: 16px;
        border-radius: 16px;
        align-self: flex-start;
    }
    .ac-player .-plist .-plist-list {
        padding: 8px 0px;
    }
    .ac-player .-plist .-plist-item {
        display: flex;
        padding: 8px;
        border-radius: 8px;
        cursor: pointer;
        margin-bottom: 4px;
    }
    .ac-player .-plist .-plist-item:hover {
        background-color: #99999915;
    }
    .ac-player .-plist .-active {
        background-color: #328866bb;
    }
    .ac-player .-plist .-plist-item-thumb {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 80px;
        height: 60px;
        background-color: #333;
        margin-right: 8px;
        border-radius: 8px;
        overflow: hidden;
    }
    .ac-player .-plist .-plist-item-thumb img {
        object-fit: cover;
        width: 100%;
        height: 100%;
    }
    .ac-player .-plist .-plist-item-content {
    }
    .ac-player .-plist .-plist-item-title {
    }
    .ac-player .-plist .-plist-item-desc {
        opacity: 0.8;
        font-size: 13px;
    }
    .ac-player .-plist .-plist-item-time {
        opacity: 0.8;
        font-size: 12px;
    }

    @media (max-width: 1300px) {
        .ac-player_outer {
            overflow: auto;
        }
        .ac-player_content {
            flex-direction: column;
        }

        .ac-player .-plist {
            flex: 1 1 auto;
            align-self: unset;
            margin-left: 0px;
        }
    }
</style>
